import React, {useContext, useEffect, useState} from 'react';

import {TableColumn, TableSettings} from "../../../tableSettings";
import AbstractListView, {
  DataFetchResult,
  ExportRowRenderer,
  ListCustomFilterRenderer,
  ListOrderBy,
  ListRowRenderer
} from "../../common/AbstractListView";

import constants from '../../../constants';

import {containerStatusList} from '../tableSettings';
import {Search} from "../../../filtering";

import {
  DateRenderer,
  DateTimeRenderer,
  FloatRenderer,
  NullableCheckboxIconRenderer,
  TextAlignLeftRenderer,
  TextAlignRightRenderer,
  TextRenderer
} from '../../../uiControls/SmartTableRenderers';
import JobListViewContext, { IJobListViewContext, RightClickContext } from '../../common/JobListViewContext';
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import InfoAreaDrawer from '../../../uiControls/infoArea/InfoAreaDrawer';
import {JobNames} from '../../../framework.core/JobNames';
import {OiContainerListItem} from '../../../fms.data/models/OiContainerListItem';
import * as XCol from '../../../framework.core/XExportColumn';
import ListViewShortcutMenu from '../../common/ListViewShortcutMenu';
import { ActionButtonItem, borderColors, splitMenuItemsIntoSections } from '../../../ui/ActionButton';
import ToolboxMenuItem from '../../../uiControls/ToolboxMenuItem';
import Menu, { IfmsMenuItem } from '../../../ui/menu/Menu';
import IfmsModal from '../../../ui/IfmsModal';
import { formatDate, formatDateTime } from '../../../dateUtils';
import Date from '../../../ui/Date';
import SecondaryButton from '../../../ui/SecondaryButton';
import { SQLField, SQLInfo, SQLType } from '../../../framework.core/data/SQLInfo';
import { ApiResult, InsertResultsWithData } from '../../../framework.core/data/ApiResult';
import fastStorage from '../../../fastStorage';
import _ from 'lodash';
import { OmContainer } from '../../../fms.core/OmContainer';
import ApplicationContext from '../../../ApplicationContext';
import { getFmsGlobal } from '../../../globals';
import { SuntekSettings, SystemSettings } from '../../../ifmsTypes';//
import {useHistory} from 'react-router-dom';
import { NavigationType, openNewPage } from '../../../util/navigationHelpers';
import { changeRQEvent, LastEventRenderer, RecognizedFilterRenderer, RecognizedRenderer, RQFilterEventRenderer } from '../../common/commonListRenderers';
import { SearchModelBase } from '../../../fms.data/models/SearchModelBase';
import { addMonths, nowDate } from '../../../dateUtils';
import periodCloseIcon from '../../../img/PeriodClose.svg';
import periodCloseIcon2 from '../../../img/periodclose-12.svg';
import opCloseIcon from '../../../img/OPClose.svg';
import opCloseIcon2 from '../../../img/opclose-12.svg';
import accountCloseIcon from '../../../img/AccountClose.svg';
import accountCloseIcon2 from '../../../img/accountingclose-12.svg';
import cntrBlue from '../../../img/cntr-tracking-rq-12-blue.svg';
import { displayLastTrackingEvent } from '../../common/commonExportFormat';
import { FmsSecTask } from '../../../fms.core/constants';
import { findSecurityTask } from '../../../util';
import { OiHbl } from '../../../fms.core/OiHbl';
import cntrGreen from '../../../img/cntr-tracking-rq-12-green.svg';

async function DoSave(rowId: number, dataIndex: any, datePopupInputValue: string|null, appContext: any, rowMblId:number) {

  
 
  let sqlInfo: SQLInfo = new SQLInfo({
    tableName: "T_OIMCONTAINER",
    type: SQLType.Update,
    fields: [
      new SQLField({ fieldName: `f_${dataIndex}`, propertyName: dataIndex, value: datePopupInputValue }),
    ],
    key: new SQLField({ fieldName: "F_Id", propertyName: "Id", value: rowId }),
  });

  const apiResult: ApiResult<InsertResultsWithData> = await appContext.api.updateContainerInfo(sqlInfo);

  const editModelKey = `editOiMbl${rowMblId}-/oceanImport/mbl/edit`;
  const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
  if (keyMatch) {
    const oimContainerArray = fastStorage[keyMatch].oimContainerList as OmContainer[];
    const oimContainer = oimContainerArray.find(x => x.id === rowId);
    if (oimContainer) {
      if (dataIndex === 'goDate')
        oimContainer.goDate = datePopupInputValue;
      else
        oimContainer.lastFreeDay = datePopupInputValue;
    }
  }
  

  if (apiResult && apiResult.success) {
    //await showGlobalOkDialog(<p>The data has been saved</p>);
  } else {
    //await showGlobalOkDialog(<div>
    //<p>Cannot save</p>
    //<p>{apiResult.message}</p>
    //</div>);
  }
}

function IndicatorRenderer({ data, row }: any) {
  const l = data[row.index];

  let dataTooltip = '';
  const lStatus = (l as any).status as string;
  if (lStatus === 'PC') dataTooltip = 'Period Close';
  else if (lStatus === 'OC') dataTooltip = 'OP Close';
  else if (lStatus === 'AC') dataTooltip = 'Accounting Close';

  let content: React.ReactNode = <></>;
  if (lStatus === 'PC')
    content = <img height="12px" src={periodCloseIcon2} id={'redIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt=""/>;
  else if (lStatus === 'OC')
    content = <img height="12px" src={opCloseIcon2} id={'blueIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt=""/>;
  else if (lStatus === 'AC')
    content = <img height="12px" src={accountCloseIcon2} id={'blackIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt=""/>;

  return (
    <div className="ifms-table-default" id={`ifms-table-default-${row.index}`}  data-tooltip={dataTooltip} style={{ width: '100%', minHeight: '22px'}}>{content}</div>
  );
}

function ClickAbleDateRenderer({ cell, data, row }: any) {
  const jobListContext = useContext(JobListViewContext);
  const l = data[row.index];

  function onDateCellClick() {
    if (jobListContext.rowExtrasId) {
      return; // Some row is already selected
    }

    jobListContext.setRowExtrasId(l.containerId);
    jobListContext.setClickedCell(cell);
  }
  let content: React.ReactNode = <></>;
  if (cell.value)
    content = formatDate(cell.value);

  return (
    <div className="ifms-table-default" style={{ width: '100%', minHeight: '16px', cursor: 'pointer' }} onClick={onDateCellClick}>{content}</div>
  );
}

function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as OiContainerListItem;
  const appContext = useContext(ApplicationContext);
  const mblSec = findSecurityTask(appContext, FmsSecTask.OIMbl);
  const hblSec = findSecurityTask(appContext, FmsSecTask.OIHbl);

  const fmsGlobal = getFmsGlobal();
  const {switchToMbl, switchToHbl} = useSelectedOperations();

  const items = [
    { label: 'Search', shortcut: 'F5', separator: false, newCol: false },
    { label: 'Go to MBL List', shortcut: 'F6', separator: false, newCol: false, hidden: !mblSec?.grantRead },
    { label: 'Go to HBL List', shortcut: 'F7', separator: true, newCol: false , hidden: !hblSec?.grantRead},
    { label: 'CNTR Tracking Info', shortcut: '', separator: false },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
    hidden: i?.hidden ?? false,
  }));

  function openContainerTracking() {
    window.open(`https://trackinginfo.suntekscm.com/?licid=${fmsGlobal.AcmeID}&cntr=${selectedElement.containerNo}`);
  }

  function onMenuItemSelected(item: IfmsMenuItem) {
    switch (item.index) {
      case 0:
        jobListContext.triggerTableSearch('F5');
        break;
      case 1:
        // switchToMbl();
        switchToMbl();
        break;
      case 2:
        // switchToMbl();
        switchToHbl();
        break;
      case 3:
        openContainerTracking();
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function CsListCommands() {
  return null;
}

function CsListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function formatData(data:Array<OiContainerListItem>) {
  return data;
}

function useOperations() {
  const history = useHistory();
  const jobListContext = useContext(JobListViewContext);

  function switchToHblFor(c: OiContainerListItem | null) {
    if (!c) {
      return;
    }


    jobListContext.setFilterForScreenExternally('/common/joblistview/hbl/oceanImport',
      'id', 'HBL', c.hblId, 'u2Date', false, true, null, 'hblNo', c.hblNo, false, true);

    openNewPage(history, `/common/joblistview/hbl/oceanImport`, NavigationType.newPage);
  }

  function switchToMblFor(c: OiContainerListItem | null) {
    if (!c) {
      return;
    }

    jobListContext.setFilterForScreenExternally('/common/joblistview/mbl/oceanImport', 
    'id', 'Ref. #', c.oiMblId, 'u2Date', false, true, null, 'refNo', c.refNo, false,true);
    
    openNewPage(history, `/common/joblistview/mbl/oceanImport`, NavigationType.newPage);
  }

  function switchToCntrFor(c: OiContainerListItem | null) {
    if (!c || !c.containerNo) {
      return;
    }

    const todayBefore3Month = addMonths(nowDate(), -3);
    let model = new SearchModelBase();
    model.extraWhere = `CntrNo in ('${c.containerNo}') and Eta >= '${todayBefore3Month}'`;
    jobListContext.setFilterForScreenExternally('/common/joblistview/hbl/oceanImport', 
      'cntrNo', 'Container', c.containerNo, 'u2Date', false, true, model);
    openNewPage(history, `/common/joblistview/hbl/oceanImport`, NavigationType.newPage);
  }

  return {switchToHblFor, switchToMblFor, switchToCntrFor};
}


function useSelectedOperations(){
  const jobListContext = useContext(JobListViewContext);
  const { switchToMblFor, switchToHblFor } = useOperations();

  function switchToMbl() {
    const selectedElement = jobListContext.selectedElement as OiContainerListItem;
    switchToMblFor(selectedElement);
  }
  
  function switchToHbl() {
    const selectedElement = jobListContext.selectedElement as OiContainerListItem;
    switchToHblFor(selectedElement);
  }

  return {switchToMbl, switchToHbl};

}


function CsListViewExtras() {
  useFunctionKeys({onFunction: onFunctionKey});

  const jobListContext = useContext(JobListViewContext);
  const {switchToMbl, switchToHbl} = useSelectedOperations();
  const [unprocessedFkey, setUnprocessedFkey] = useState<string|null>(null);
  const appContext = useContext(ApplicationContext);
  const mblSec = findSecurityTask(appContext, FmsSecTask.OIMbl);
  const hblSec = findSecurityTask(appContext, FmsSecTask.OIHbl);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === "F6") {
      if (mblSec.grantRead)
        switchToMbl();
    } else if (unprocessedFkey === "F7") {
      if (hblSec.grantRead)
        switchToHbl();
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey:string) {
    if (['F6','F7','F11'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  return (
    <InfoAreaDrawer
      showContent={jobListContext.infoAreaContent}
      jobName={JobNames.OIContainer}
      jobId={(jobListContext.selectedElement as OiContainerListItem|null)?.containerId ?? 0}
      onClose={() => jobListContext.setInfoAreaContent('none')}
      //hideLogHistory={true}
    />
  );
}

function ContainerPopup({ rowId, onClose, cell, save }: { rowId: any, onClose: any, cell: any, save: any }) {
  const [datePopupInputValue, setDatePopupInputValue] = useState<string | null>(null);

  
  return (
    <IfmsModal isBlueHeader cancelOnEsc onCancel={onClose} draggable isOpen title={`Input - ${cell.column.Header}`} width="260px">
      <div className='report-popup'>
        <div style={{ height: '30px', display: 'flex' }}>
          <span>{cell.column.Header}</span>
          <div style={{ width: '80px', marginLeft: '10px', marginTop: '-1px' }}>
            <Date
              value={formatDate(datePopupInputValue ? datePopupInputValue : cell.value)}
              onChange={date => { setDatePopupInputValue(date ?? null) }}
            />
          </div>
        </div>
        <div className="report-footer" >
           <SecondaryButton size="regular" focusable={true} onClick={() => { save(rowId, cell.column.dataIndex, datePopupInputValue) }}>
            SAVE
          </SecondaryButton>&nbsp;&nbsp;
          <SecondaryButton size="regular" focusable={true} onClick={onClose}>
            CANCEL
          </SecondaryButton>
        </div>
      </div>
    </IfmsModal>
  );
}

/**
 * Concrete implementation for Container List screen
 *
 * @class ContainerStatusListView
 * @extends {AbstractListView}
 */
 class ContainerStatusListView extends AbstractListView {
  async fetchAndFormatData(api: any, search: Search, pageNum: number, limit: number): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(JobNames.OIContainer, 'OiContainerListItem',
    OiContainerListItem.calculateSearchParameters(search, OiContainerListItem.MapSearchFields),
    pageNum,
    limit,
    search.pageSize,
    search.pagePerBatch,
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }

    return { data: formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }

  async exportFormatDataWithExcel(api: any, search: Search, pageNum: number, limit: number, pageSize: number, pagePerBatch: number): Promise<Array<any>> {
    const apiResult = await api.getListItems(JobNames.OIContainer, 'OiContainerListItem',
      OiContainerListItem.calculateSearchParameters(search,OiContainerListItem.MapSearchFields),
      pageNum,
      limit,
      pageSize,
      pagePerBatch,
      'AMS'
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return [];
    }

    return formatData(apiResult.entities);
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
      {
        accessor: 'trStatus',
        renderer: RQFilterEventRenderer,
        searchValueExtractor: (v:any|null|undefined) => v !== null ? changeRQEvent(v): "",
      },
      // {
      //   accessor: 'recognized',
      //   renderer: RecognizedFilterRenderer,
      //   searchValueExtractor: (v:any|null|undefined) => v,
      // },
    ];
  }

  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanImportMbl;
  }

  getRowRenderers(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings, listCount: number, useDarkMode: boolean ): ListRowRenderer[] {
    return OiContainerListItem.getExportCollection().map(x => {
      const colRenderer:ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      //if(x.dataIndex === 'containerNo') {
        //colRenderer.Cell = CntrNoRenderer;
        //   colRenderer.Header = () => <span><u>Container No</u></span>;
      //}
      if(x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      if(x.align === XCol.XAlignType.Right) colRenderer.Cell = TextAlignRightRenderer;
      if(x.dataIndex === 'status') {
        colRenderer.Cell = IndicatorRenderer;
        //colRenderer.Header = () => <span></span>;
      }
      //else if(x.dataIndex === 'recognized') { colRenderer.Cell = RecognizedRenderer; }
      //else if(x.dataIndex === "refNo") colRenderer.Cell = RefRenderer;
      //else if(x.dataIndex === "mblNo") colRenderer.Cell = MblRenderer;
      else if(x.dataIndex === 'trStatus'){
        colRenderer.Cell = (props: any) => <LastEventRenderer {...props} jobName={JobNames.OEContainer} />;
        colRenderer.Header =  () => <div style={{gap:'4px', display:'flex'}}><img src={useDarkMode ? cntrGreen: cntrBlue} alt='' /><div>Container Tracking</div></div>;
      }
      else if(x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if (x.type === XCol.XCellType.Date) {
        if (x.dataIndex === "eta" || x.dataIndex === "etd" || x.dataIndex === 'inlandEta' || x.dataIndex === 'mblCreatedDate' || x.dataIndex === 'confirmDate')
          colRenderer.Cell = DateRenderer
        else {
          colRenderer.Cell = ClickAbleDateRenderer
        }
      }
      else if(x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      else if (x.type === XCol.XCellType.Double) {
        if (x.dataIndex === 'pkgs')
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={0} />;
        else
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={2} />;
      }
      return colRenderer;
    });
  }
 
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({ 
      accessor: 'status', 
      changedValue: (value: any) => {  
          return value === 'PC' ? 'Period Close' :
                  value === 'OC' ? 'OP Close' :
                  value === 'AC' ? 'Accounting Close' :
                  '';
      }
    });
    //colRenderer.push({ accessor: 'recognized', changedValue: (value: any) => { return value['recognized'] }});
    colRenderer.push({ accessor: 'prepBy', changedValue: (value: any) => { return value['prepBy'] }});
    colRenderer.push({ accessor: 'containerNo', changedValue: (value: any) => { return value['containerNo'] }});
    colRenderer.push({ accessor: 'conType', changedValue: (value: any) => { return value['conType'] } });
    colRenderer.push({ accessor: 'refNo', changedValue: (value: any) => { return value['refNo'] } });
    colRenderer.push({ accessor: 'trDate', changedValue: (value: any) => { return formatDateTime(value['trDate']) } });
    colRenderer.push({ accessor: 'trStatus', changedValue: (value: any) => { return displayLastTrackingEvent(value) } });
    colRenderer.push({ accessor: 'ord', changedValue: (value: any) => { return formatDate(value['ord']) } });
    colRenderer.push({ accessor: 'inDate', changedValue: (value: any) => { return formatDate(value['inDate']) } });
    colRenderer.push({ accessor: 'loadDate', changedValue: (value: any) => { return formatDate(value['loadDate']) } });
    colRenderer.push({ accessor: 'atd', changedValue: (value: any) => { return formatDate(value['atd']) } });
    colRenderer.push({ accessor: 'ata', changedValue: (value: any) => { return formatDate(value['ata']) } });
    colRenderer.push({ accessor: 'unloadDate', changedValue: (value: any) => { return formatDate(value['unloadDate']) } });
    colRenderer.push({ accessor: 'rAtd', changedValue: (value: any) => { return formatDate(value['rAtd']) } });
    colRenderer.push({ accessor: 'inlandEta', changedValue: (value: any) => { return formatDate(value['inlandEta']) } });
    colRenderer.push({ accessor: 'rAta', changedValue: (value: any) => { return formatDate(value['rAta']) } });
    colRenderer.push({ accessor: 'lastFreeDay', changedValue: (value: any) => { return formatDate(value['lastFreeDay']) } });
    colRenderer.push({ accessor: 'puDate', changedValue: (value: any) => { return formatDate(value['puDate']) } });
    colRenderer.push({ accessor: 'outDate', changedValue: (value: any) => { return formatDate(value['outDate']) } });
    colRenderer.push({ accessor: 'dcDate', changedValue: (value: any) => { return formatDate(value['dcDate']) } });
    colRenderer.push({ accessor: 'emptyReturn', changedValue: (value: any) => { return formatDate(value['emptyReturn']) } });
    colRenderer.push({ accessor: 'etd', changedValue: (value: any) => { return formatDate(value['etd']) } });
    colRenderer.push({ accessor: 'eta', changedValue: (value: any) => { return formatDate(value['eta']) } });
    colRenderer.push({ accessor: 'mblNo', changedValue: (value: any) => { return value['mblNo'] } });
    colRenderer.push({ accessor: 'loadingPort', changedValue: (value: any) => { return value['loadingPort'] } });
    colRenderer.push({ accessor: 'dischargePort', changedValue: (value: any) => { return value['dischargePort'] } });
    colRenderer.push({ accessor: 'placeOfDelivery', changedValue: (value: any) => { return value['placeOfDelivery'] } });
    colRenderer.push({ accessor: 'vessel', changedValue: (value: any) => { return value['vessel'] } });
    colRenderer.push({ accessor: 'voyage', changedValue: (value: any) => { return value['voyage'] } });
    colRenderer.push({ accessor: 'carrierRls', changedValue: (value: any) => { return formatDate(value['carrierRls']) } });
    colRenderer.push({ accessor: 'customRls', changedValue: (value: any) => { return formatDate(value['customRls']) } });
    colRenderer.push({ accessor: 'mblCreatedDate', changedValue: (value: any) => { return formatDate(value['mblCreatedDate']) } });
    colRenderer.push({ accessor: 'mblCreateBy', changedValue: (value: any) => { return value['mblCreateBy'] } });
    colRenderer.push({ accessor: 'trCreatedBy', changedValue: (value: any) => { return value['trCreatedBy'] } });
    // colRenderer.push({ accessor: 'pkgs', changedValue: (value: any) => { return value['pkgs'] } });
    // colRenderer.push({ accessor: 'bookingDate', changedValue: (value: any) => { return formatDate(value['bookingDate']) } });
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'containerId',
      orderByAscending: false,
     };
   }

   renderRowExtras(rowId: number | null, context: IJobListViewContext, cell: any, appContext: any): React.ReactNode | null {
     if (!rowId) {
       return null;
     }

     function onClose() {
       context.setRowExtrasId(null);
       context.setClickedCell(null);
     }
    function save(rowId: number, dataIndex: any, datePopupInputValue: string) {
       if (cell.value !== datePopupInputValue) {
         DoSave(rowId, dataIndex, datePopupInputValue, appContext, cell.row.original.oiMblId);
         onClose();
         context.reloadData();
       }
       else
         onClose();
     }

     return <ContainerPopup rowId={rowId} onClose={onClose} save={save} cell={cell} />
   }

  getTableSettings(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): TableSettings {
    const tsettings = containerStatusList;
    const cols = OiContainerListItem.getExportCollection();
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });

    return tsettings;
    
  }
  
  renderCommands() {
    return (
      <CsListCommands />
    );
  }

  renderBeforeConfigureButton() {
    return (
      <CsListToolbar />
    );
  }


  renderExtras() {
    return <CsListViewExtras />
  }

  getViewUrlFor() {
    return '';
  }

  getListViewTitle() {
    return 'Container List (OI)';
  };

  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }
};

export default ContainerStatusListView;
